import { xcss } from '@atlaskit/primitives';

export const modalBoxStyles = xcss({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});
